import { createSlice } from '@reduxjs/toolkit'

export const CustomerDetailsSlice = createSlice({
  name: 'customerDetailsInfo',
  initialState: {
    customerDetails: null,
    updateStatus: false,
  },
  reducers: {
    setCustomerDetails: (state, action) => {
      state.customerDetails = action.payload
    },
    setUpdateStatus: (state, action) => {
      state.updateStatus = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setCustomerDetails, setUpdateStatus } = CustomerDetailsSlice.actions

export default CustomerDetailsSlice.reducer